/* Two-slide homepage hero: dots, swipe, and gentle autoplay. */
(function () {
  var AUTOPLAY_MS = 5500;

  function init(scope) {
    var hosts = (scope || document).querySelectorAll('.hero-pair');
    hosts.forEach(function (host) {
      if (host.dataset.heroPairInit === 'true') return;
      host.dataset.heroPairInit = 'true';

      var track = host.querySelector('.hero-pair__track');
      if (!track) return;
      var slides = track.querySelectorAll('.hero-pair__slide');
      if (slides.length < 2) return;

      var existing = host.querySelector('.hero-pair__dots');
      if (existing) existing.remove();

      var dots = document.createElement('div');
      dots.className = 'hero-pair__dots';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          go(i, true);
        });
        dots.appendChild(dot);
      });
      host.appendChild(dots);

      var index = 0;
      var timer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setDots(active) {
        dots.querySelectorAll('button').forEach(function (dot, i) {
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function go(i, user) {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: track.clientWidth * index, behavior: user || reduceMotion ? 'smooth' : 'smooth' });
        setDots(index);
        if (user) restart();
      }

      function next() {
        go(index + 1, false);
      }

      function restart() {
        if (reduceMotion) return;
        if (timer) clearInterval(timer);
        timer = setInterval(next, AUTOPLAY_MS);
      }

      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var active = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (active !== index) {
              index = active;
              setDots(index);
            }
          });
        },
        { passive: true }
      );

      host.addEventListener('mouseenter', function () {
        if (timer) clearInterval(timer);
      });
      host.addEventListener('mouseleave', restart);
      host.addEventListener('focusin', function () {
        if (timer) clearInterval(timer);
      });
      host.addEventListener('focusout', restart);

      window.addEventListener('resize', function () {
        track.scrollLeft = track.clientWidth * index;
      });

      restart();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
